"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSFRAFetch = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _url = require("pwa-kit-react-sdk/utils/url");
var _crossFetch = _interopRequireDefault(require("cross-fetch"));
var _querystring = _interopRequireDefault(require("querystring"));
var _utils = require("../commerce-api/utils");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; } // @ts-ignore
const SESSION_EXPIRE_TIME_IN_MINUTES = 15;
const createOCAPISession = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)(function* (config) {
    return new Promise(resolve => {
      const isOnClient = typeof window !== 'undefined';
      if (!isOnClient) return resolve(false);
      const ocapiFetch = (0, _utils.createOcapiFetch)(config);
      const sessionKey = 'ocapiSessionCreationTime';
      const refreshTokenGuestStorageKey = 'cc-nx-g';
      const refreshTokenRegisteredStorageKey = 'cc-nx';
      const currentTime = new Date();
      const ocapiSessionCreationTime = window.sessionStorage.getItem(sessionKey);
      const isGuest = window.localStorage.getItem(refreshTokenGuestStorageKey) !== null;
      const isRegistered = window.localStorage.getItem(refreshTokenRegisteredStorageKey) !== null;
      const hasSessionExpired = ocapiSessionCreationTime === null ||
      // @ts-ignore
      Math.round(currentTime - new Date(ocapiSessionCreationTime)) / 1000 / 60 >= SESSION_EXPIRE_TIME_IN_MINUTES;
      const sessionRequestOptions = [{
        headers: {
          Authorization: window.localStorage.getItem('token')
        }
      }];
      if (hasSessionExpired && !isGuest && isRegistered) {
        // @ts-ignore
        return ocapiFetch('sessions', 'POST', sessionRequestOptions, 'createOCAPISession').then(() => {
          window.sessionStorage.setItem(sessionKey, new Date().toISOString());
          resolve(true);
        }).catch(() => {
          window.sessionStorage.removeItem(sessionKey);
          resolve(false);
        });
      }
      resolve(false);
    });
  });
  return function createOCAPISession(_x) {
    return _ref.apply(this, arguments);
  };
}();

// This function is used to interact with the SFRA API
const createSFRAFetch = config => /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)(function* (endpoint, method, args, methodName) {
    const siteId = config.parameters.siteId;
    const locale = config.locale ? config.locale.replace('-', '_') : 'default';
    const queryString = _querystring.default.stringify(args.query);
    const host = config.ocapiHost ?
    // @ts-ignore
    `https://${commerceAPIConfig.ocapiHost}` : `${(0, _url.getAppOrigin)()}${config.proxyPath}`;
    const options = {
      method,
      headers: _objectSpread(_objectSpread({
        'Content-Type': 'application/json',
        'x-dw-client-id': config.parameters.clientId
      }, config === null || config === void 0 ? void 0 : config.headers), args === null || args === void 0 ? void 0 : args.headers),
      body: args.body ? typeof args.body === 'object' ? JSON.stringify(args.body) : args.body : undefined
    };
    return new Promise((resolve, reject) => {
      createOCAPISession(config).then(() => {
        const baseUrl = config.alias ? `${host}/s/${siteId}/${locale}` : `${host}/on/demandware.store/Sites-${siteId}-Site/${locale}`;
        (0, _crossFetch.default)(`${baseUrl}/${endpoint}?${queryString}`, options).then( /*#__PURE__*/function () {
          var _ref3 = (0, _asyncToGenerator2.default)(function* (response) {
            let result;
            try {
              result = response.json && (yield response.json());
            } catch (e) {
              console.error(`Error parsing response as json for ${methodName}: `, e);
              try {
                result = response.text && (yield response.text());
              } catch (e) {
                console.error(`Error parsing response as for ${methodName}: `, e);
              }
            }
            !result || result.error || response.status >= 400 ? reject(result) : resolve(result);
          });
          return function (_x6) {
            return _ref3.apply(this, arguments);
          };
        }()).catch(error => reject(error));
      });
    });
  });
  return function (_x2, _x3, _x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();
exports.createSFRAFetch = createSFRAFetch;